<template>
  <div class="page-wrap campus-manage">
    <transition name="default" mode="out-in">
      <router-view
        :update-component="updateComponent"
        :key="$route.path"
      ></router-view>
    </transition>
  </div>
</template>

<script>
import PageHeader from '../../components/PageHeader.vue'
import { mapGetters } from 'vuex'
import aliOSS from 'ali-oss'

export default {
  components: {
    PageHeader
  },

  data() {
    return {
      updateComponent: new Date().toString()
    }
  },

  computed: {
    ...mapGetters(['categoryRouterList', 'handleRightsList'])
  },

  methods: {
    handleTap(component) {
      this.$router.push({
        name: component.name
      })
    }
  }
}
</script>
